// extracted by mini-css-extract-plugin
export var cards = "ParagraphFAQ-module--cards--8db15";
export var faqheading = "ParagraphFAQ-module--faqheading--a43b1";
export var heading = "ParagraphFAQ-module--heading--efcfa";
export var paragraphfaqinner = "ParagraphFAQ-module--paragraphfaqinner--f53f0";